<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div v-if="hasModuleCustomSMTPCliente || hasModuleCustomLogo || hasModuleCustomColors || hasModuleCustomMails || hasModuleCustomSMTPZerocoma" class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          
          <base-collapsible-form 
            v-if="hasModuleCustomLogo"
            ref="baseCollapsibleLogo" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.logo_custom')}}</h2>
                <base-tooltip-icon size="sm" :section="$t('clients.logo_custom')" :content="tooltipContentLogo" class="ml-2"/>
              </div>
            </template>

            <template slot="content">
            <div>
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('app.mode_light')}}</label>
                <div class="-mx-2">
                  <div class="px-2 mb-2 lg:mb-0">
                    <el-form-item prop="fileLight" ref="uploadlogo">
                      <Upload
                        role="button"
                        ref="upload"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        accept="image/png,image/webp,image/jpeg"
                        :show-file-list="false"
                        :multiple="false"
                        :auto-upload=false
                        :on-remove="handleRemoveLight"
                        :on-change="handleChangeLight">
                        <i class="el-icon-upload"></i>
                        <p v-if="fileLight.name" class="el-upload__text"><em>{{fileLight.name}}</em></p>
                        <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                      </Upload>
                    </el-form-item>
                    <div class="">
                      <div v-if="validLightImage" class="pb-10 ">
                        <div class="flex items-center gap-x-2 mb-2">
                          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">
                            {{$t('clients.logo_custom_previsualizacion')}}
                          </label>
                          <base-button-icon 
                            v-if="hasLogoLightSaved" 
                            ariaLabel="Eliminar logo (modo claro)"
                            name="cross" 
                            size="xs" 
                            iconSize="xs" 
                            mode="primary-phantom" 
                            @click="handleRemoveLight"/>
                        </div>
                        <div v-if="!croppedLight">
                          <Cropper
                            ref="cropperLight"
                            :src="srcImageLight" 
                            :stencil-props="stencilProps"
                          />
                          <div class="w-full flex justify-end mt-4">
                            <base-button 
                              mode="primary" 
                              :text="$t('app.recortar')" 
                              @click="recortarModoClaro" 
                              :loading="isGeneralLoading"/>
                          </div>
                        </div>

                        <div class="flex items-center gap-x-2 mt-1"
                          v-if="croppedLight"
                          >
                          <img 
                            id="logo-custom-client-light" 
                            ref="logo-custom-client-light" 
                            :src="'data:image/png;base64, ' + fileLight.b64" 
                            :alt="$t('clients.logo_custom_light')" 
                            class="w-[304px] h-[78px] border-2 border-solid border-primary-300 dark:bg-white rounded object-scale-down object-left"/>
                        </div>
                      </div>
                      <div v-else class="flex flex-col pb-10 ">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">Ningún logo seleccionado, se utilizará el predeterminado</label>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div>
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('app.mode_dark')}}</label>
                <div class="-mx-2">
                  <div class="px-2 mb-2 lg:mb-0">
                    <el-form-item prop="fileDark" ref="uploadlogo">
                      <Upload
                        role="button"
                        ref="upload"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        accept="image/png,image/webp,image/jpeg"
                        :show-file-list="false"
                        :multiple="false"
                        :auto-upload=false
                        :on-remove="handleRemoveDark"
                        :on-change="handleChangeDark">
                        <i class="el-icon-upload"></i>
                        <p v-if="fileDark.name" class="el-upload__text"><em>{{fileDark.name}}</em></p>
                        <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                      </Upload>
                    </el-form-item>
                    <div class="">
                      <div v-if="validDarkImage" class="pb-10 ">
                        <div class="flex items-center gap-x-2 mb-2">
                          <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">
                            {{$t('clients.logo_custom_previsualizacion')}}
                          </label>
                          <base-button-icon 
                            v-if="hasLogoDarkSaved" 
                            ariaLabel="Eliminar logo (modo oscuro)"
                            name="cross" 
                            size="xs"
                            iconSize="xs" 
                            mode="primary-phantom" 
                            @click="handleRemoveDark"/>
                        </div>
                        
                        <div v-if="!croppedDark">
                          <Cropper
                            ref="cropperDark"
                            :src="srcImageDark" 
                            :stencil-props="stencilProps"
                          />
                          <div class="w-full flex justify-end mt-4">
                            <base-button 
                              mode="primary" 
                              :text="$t('app.recortar')" 
                              @click="recortarModoOscuro" 
                              :loading="isGeneralLoading"/>
                          </div>
                        </div>

                        <div class="flex items-center gap-x-2 mt-1"
                          v-if="croppedDark"
                          >
                          <img 
                            id="logo-custom-client-dark" 
                            ref="logo-custom-client-dark" 
                            :src="'data:image/png;base64, ' + fileDark.b64" 
                            :alt="$t('clients.logo_custom_dark')" 
                            class="w-[304px] h-[78px] border-2 border-solid border-primary-300 bg-darkblue-800 rounded object-scale-down object-left"/>
                          </div>
                      </div>
                      <div v-else class="flex flex-col pb-10 ">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">Ningún logo seleccionado, se utilizará el predeterminado</label>
                      </div>
                    </div>
                  </div>
                </div>              
            </div>
            </template>

          </base-collapsible-form>

          <base-collapsible-form 
            v-if="hasModuleCustomColors"
            ref="baseCollapsibleColors" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.colors_custom')}}</h2>
                <!-- <base-tooltip-icon size="sm" :content="tooltipContentColors" class="ml-2"/> -->
              </div>
            </template>
            <template slot="content">

              <div class="flex items-center gap-x-2 mb-4">
               <label v-if="colorSelected" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('clients.colors_custom_selected')}}</label>
               <label v-else class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('clients.colors_custom_not_selected')}}</label>
                <el-color-picker
                  v-model="colorSelected"
                  :predefine="predefineColors">
                </el-color-picker>
                <p class="hidden">{{colorSelected}}</p>
              </div>
              <p v-if="colorSelected" class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 mb-6">
                {{$t('clients.colors_custom_extend')}}
              </p>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="hasModuleCustomSMTPCliente || hasModuleCustomSMTPZerocoma"
            ref="baseCollapsibleCustomMailSmtp" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_smtp')}}</h2>
            </template>
            <template slot="content">

            <div class="mb-4">
              <label for="switch-smtp-main" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('smtp.main')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('smtp.default')}} / {{$t('smtp.custom')}}</span>
              </label>
              <el-switch 
                id="switch-smtp-main"
                :aria-label="$t('smtp.main')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.smtpMain" 
                :active-text="$t('smtp.custom')"
                :inactive-text="$t('smtp.default')"
                inactive-color="var(--primary-800)"
                />
            </div>

            <div v-if="form.smtpMain">
              <div class="lg:mb-2">
                <div class="mandatory">
                  <span id="personalization-smtp-server-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.server')}}</span>
                  <el-form-item prop="smtpServer">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-smtp-server-label"
                      v-model="form.smtpServer"
                      maxlength='200'
                      >
                      <template v-if="form.smtpServer" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de servidor SMTP"
                          @clear="form.smtpServer = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <span id="personalization-smtp-from-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.from')}}</span>
                  <el-form-item prop="smtpFrom">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-smtp-from-label"
                      v-model="form.smtpFrom"
                      maxlength='100'
                      autocomplete="email"
                      >
                      <template v-if="form.smtpFrom" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de correo remitente SMTP"
                          @clear="form.smtpFrom = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <span id="personalization-smtp-port-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.port')}}</span>
                  <el-form-item prop="smtpPort">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-smtp-port-label"
                      v-model.number="form.smtpPort"
                      maxlength='10'
                      >
                      <template v-if="form.smtpPort" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de puerto SMTP"
                          @clear="form.smtpPort = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="mb-4">
                <label for="switch-smtp-ssl" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.ssl')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                </label>
                <el-switch 
                  id="switch-smtp-ssl"
                  :aria-label="$t('smtp.ssl')"
                  class="switch-text break-normal both-switch mt-2" 
                  v-model="form.smptSSL" 
                  :active-text="$t('companies.active')"/>
              </div>
              
              <div class="mb-4">
                <label for="switch-smtp-relay" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.relay')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                </label>
                <el-switch 
                  id="switch-smtp-relay"
                  :aria-label="$t('smtp.relay')"
                  class="switch-text break-normal both-switch mt-2" 
                  :disabled="form.smptOAuth2"
                  v-model="form.smtpRelay" 
                  :active-text="$t('companies.active')"/>
              </div>

              <div class="mb-4">
                <label for="switch-smtp-oauth2" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.oauth2')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                </label>
                <el-switch 
                  id="switch-smtp-oauth2"
                  :aria-label="$t('smtp.oauth2')"
                  class="switch-text break-normal both-switch mt-2" 
                  :disabled="form.smtpRelay"
                  v-model="form.smptOAuth2" 
                  :active-text="$t('companies.active')"/>
              </div>

              <div class="lg:mb-2" v-if="form.smptOAuth2">
                <div class="mandatory">
                  <span id="personalization-smtp-client-id-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.clientid')}}</span>
                  <el-form-item prop="smptClientId">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-smtp-client-id-label"
                      v-model="form.smptClientId"
                      maxlength='100'
                      >
                      <template v-if="form.smptClientId" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de Client ID SMTP"
                          @clear="form.smptClientId = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.smptOAuth2">
                <div class="mandatory">
                  <span id="personalization-smtp-tenant-id-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.tenantid')}}</span>
                  <el-form-item prop="smptTenantId">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-smtp-tenant-id-label"
                      v-model="form.smptTenantId"
                      maxlength='100'
                      >
                      <template v-if="form.smptTenantId" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de Tenant ID SMTP"
                          @clear="form.smptTenantId = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="!form.smtpRelay">
                <div class="mandatory">
                  <span id="personalization-smtp-user-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.user')}}</span>
                  <el-form-item prop="smtpUser">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-smtp-user-label"
                      v-model="form.smtpUser"
                      maxlength='100'
                      >
                      <template v-if="form.smtpUser" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de usuario SMTP"
                          @clear="form.smtpUser = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="!form.smtpRelay">
                <div class="mandatory">
                  <span id="personalization-smtp-pass-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.pass')}}</span>
                  <el-form-item prop="smtpPass">
                    <el-input
                      ref="passwordInputPassPersonalization"
                      aria-labelledby="personalization-smtp-pass-label"
                      :disabled="disableEditPass"
                      show-password
                      class="w-full"
                      v-model="form.smtpPass"
                      autocomplete="new-password"
                      maxlength='100'
                    >
                      <template v-if="form.smtpPass && !disableEditPass" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de contraseña SMTP"
                          @clear="form.smtpPass = ''"
                        />
                      </template>
                      <base-button-icon
                        v-if="visibleEditPass"
                        slot="append" 
                        @click="editSmtpPassToggle()"
                        :name="disableEditPass ? 'editpencil' : 'cross'"
                        :ariaLabel="disableEditPass ? 'Editar contraseña' : 'Cancelar edición de contraseña'"
                        iconSize="md"
                        size="xs"
                        mode="primary-phantom"
                        class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                      />
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <!-- <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('smtp.confirmacion_entrega')}}
                  <el-switch 
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.smptConfirmacionEntrega" 
                    :active-text="$t('companies.active')"/>
                </label>
              </div> -->
            </div>

            </template>
          </base-collapsible-form>

          <div v-if="hasModuleCustomMails">
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailHeaderNEOs" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_neos')}}</h2>
            </template>
            <template slot="content">
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailNew" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_new')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-new-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailNew">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-new-label"
                      v-model="form.asuntoMailNew"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailNew" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailNew = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailNew"
                  :contentDefault="!customMailNew ? msgDefaultDisabledEditor : contentTextEditorDefaultNew"
                  idDefault="customMailNew"
                  class="mb-4 overflow-visible"
                  :tags="tagsCustomMailNew"
                  :disableEditor="!customMailNew"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
          
            </template>
          </base-collapsible-form>
          
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailDownload" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_download')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-download-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailDownload">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-download-label"
                      v-model="form.asuntoMailDownload"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailDownload" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailDownload = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailDownload"
                  :contentDefault="!customMailDownload ? msgDefaultDisabledEditor : contentTextEditorDefaultDownload"
                  idDefault="customMailDownload"
                  class="mb-4"
                  :tags="tagsCustomMailDownload"
                  :disableEditor="!customMailDownload"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
          
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailAviso" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_aviso')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-aviso-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailAviso">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-aviso-label"
                      v-model="form.asuntoMailAviso"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailAviso" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailAviso = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailAviso"
                  :contentDefault="!customMailAviso ? msgDefaultDisabledEditor : contentTextEditorDefaultAviso"
                  idDefault="customMailAviso"
                  class="mb-4"
                  :tags="tagsCustomMailAviso"
                  :disableEditor="!customMailAviso"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>
          
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailTramit" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_tramit')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-tramit-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailTramit">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-tramit-label"
                      v-model="form.asuntoMailTramit"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailTramit" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailTramit = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailTramit"
                  :contentDefault="!customMailTramit ? msgDefaultDisabledEditor : contentTextEditorDefaultTramit"
                  idDefault="customMailTramit"
                  class="mb-4"
                  :tags="tagsCustomMailTramit"
                  :disableEditor="!customMailTramit"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailVinc" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_vinc')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-vinc-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailVinc">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-vinc-label"
                      v-model="form.asuntoMailVinc"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailVinc" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailVinc = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailVinc"
                  :contentDefault="!customMailVinc ? msgDefaultDisabledEditor : contentTextEditorDefaultVinc"
                  idDefault="customMailVinc"
                  class="mb-4"
                  :tags="tagsCustomMailVinc"
                  :disableEditor="!customMailVinc"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailVincEnlace" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_vinc_enlace')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-vinc-enlace-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailVincEnlace">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-vinc-enlace-label"
                      v-model="form.asuntoMailVincEnlace"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailVincEnlace" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailVincEnlace = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailVincEnlace"
                  :contentDefault="!customMailVincEnlace ? msgDefaultDisabledEditor : contentTextEditorDefaultVincEnlace"
                  idDefault="customMailVincEnlace"
                  class="mb-4"
                  :tags="tagsCustomMailVincEnlace"
                  :disableEditor="!customMailVincEnlace"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailManual" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_manual')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-manual-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailManual">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-manual-label"
                      v-model="form.asuntoMailManual"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailManual" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailManual = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailManual"
                  :contentDefault="!customMailManual ? msgDefaultDisabledEditor : contentTextEditorDefaultManual"
                  idDefault="customMailManual"
                  class="mb-4"
                  :tags="tagsCustomMailManual"
                  :disableEditor="!customMailManual"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          </template>
        </base-collapsible-form>
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailHeaderLicenciamiento" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_licenciamiento')}}</h2>
            </template>
            <template slot="content">

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailNeos" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_neos')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-neos-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailNeos">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-neos-label"
                      v-model="form.asuntoMailNeos"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailNeos" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailNeos = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailNeos"
                  :contentDefault="!customMailNeos ? msgDefaultDisabledEditor : contentTextEditorDefaultNeos"
                  idDefault="customMailNeos"
                  class="mb-4"
                  :tags="tagsCustomMailNeos"
                  :disableEditor="!customMailNeos"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailEspacio" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_espacio')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-espacio-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailEspacio">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-espacio-label"
                      v-model="form.asuntoMailEspacio"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailEspacio" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailEspacio = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailEspacio"
                  :contentDefault="!customMailEspacio ? msgDefaultDisabledEditor : contentTextEditorDefaultEspacio"
                  idDefault="customMailEspacio"
                  class="mb-4"
                  :tags="tagsCustomMailEspacio"
                  :disableEditor="!customMailEspacio"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailSMS" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_sms')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-sms-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailSMS">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-sms-label"
                      v-model="form.asuntoMailSMS"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailSMS" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailSMS = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailSMS"
                  :contentDefault="!customMailSMS ? msgDefaultDisabledEditor : contentTextEditorDefaultSMS"
                  idDefault="customMailSMS"
                  class="mb-4"
                  :tags="tagsCustomMailSMS"
                  :disableEditor="!customMailSMS"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          </template>
        </base-collapsible-form>
          <base-collapsible-form 
            ref="baseCollapsibleCustomMailHeaderUsers" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_header_users')}}</h2>
            </template>
            <template slot="content">

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailNuevoUsuario" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_nuevo_usuario')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-nuevo-usuario-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailNuevoUsuario">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-nuevo-usuario-label"
                      v-model="form.asuntoMailNuevoUsuario"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailNuevoUsuario" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailNuevoUsuario = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailNuevoUsuario"
                  :contentDefault="!customMailNuevoUsuario ? msgDefaultDisabledEditor : contentTextEditorDefaultNuevoUsuario"
                  idDefault="customMailNuevoUsuario"
                  class="mb-4"
                  :tags="tagsCustomMailNuevoUsuario"
                  :disableEditor="!customMailNuevoUsuario"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailRecuperacionPass" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_recuperacion_pass')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-recuperacion-pass-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailRecuperacionPass">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-recuperacion-pass-label"
                      v-model="form.asuntoMailRecuperacionPass"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailRecuperacionPass" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailRecuperacionPass = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailRecuperacionPass"
                  :contentDefault="!customMailRecuperacionPass ? msgDefaultDisabledEditor : contentTextEditorDefaultRecuperacionPass"
                  idDefault="customMailRecuperacionPass"
                  class="mb-4"
                  :tags="tagsCustomMailRecuperacionPass"
                  :disableEditor="!customMailRecuperacionPass"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailDobleAuth" 
            class="ml-2 mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_doble_auth')}}</h3>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-doble-auth-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailDobleAuth">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-doble-auth-label"
                      v-model="form.asuntoMailDobleAuth"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailDobleAuth" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailDobleAuth = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailDobleAuth"
                  :contentDefault="!customMailDobleAuth ? msgDefaultDisabledEditor : contentTextEditorDefaultDobleAuth"
                  idDefault="customMailDobleAuth"
                  class="mb-4"
                  :tags="tagsCustomMailDobleAuth"
                  :disableEditor="!customMailDobleAuth"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>
            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleCustomMailOtrosAvisos" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.custom_mail_otros_avisos')}}</h2>
            </template>
            <template slot="content">

              <div class="lg:mb-2">
                <span id="personalization-asunto-mail-otros-avisos-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_asunto')}}</span>
                  <el-form-item prop="asuntoMailOtrosAvisos">
                    <el-input
                      class="w-full"
                      aria-labelledby="personalization-asunto-mail-otros-avisos-label"
                      v-model="form.asuntoMailOtrosAvisos"
                      maxlength='255'
                      >
                        <template v-if="form.asuntoMailOtrosAvisos" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de asunto del mail"
                            @clear="form.asuntoMailOtrosAvisos = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
              </div>

              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.mail_cuerpo')}}</label>
                <TextEditor
                  ref="textEditorCustomMailOtrosAvisos"
                  :contentDefault="!customMailOtrosAvisos ? msgDefaultDisabledEditor : contentTextEditorDefaultOtrosAvisos"
                  idDefault="customMailOtrosAvisos"
                  class="mb-4"
                  :tags="tagsCustomMailOtrosAvisos"
                  :disableEditor="!customMailOtrosAvisos"
                  :metadatosAdicionales="valuesCamposMetadatos"
                  />
              </div>
            </template>
          </base-collapsible-form>

          </div>
        </div>
        </el-form>
      </div>
      <div v-else class="lg:max-w-detail lg:mr-auto">
        <div class="lg:mb-2">
          <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.modules_personalization_empty')}}</label>
        </div>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive 
            mode="secondary" 
            :text="isFromClient ? $t('app.cancel') : $t('app.back')" 
            icon="cross" 
            @click="goBack" 
            :loading="isGeneralLoading"/>
          <base-button-responsive 
            mode="primary" 
            v-if="
             (hasModuleCustomSMTPCliente || (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')) &&
             showTestHotFolder && 
             form.smtpMain" 
            :text="$t('app.test_btn_smtp')" 
            icon="mailtest" 
            @click="submitForm('ruleForm', true)" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"
          />
          <base-button-responsive 
            mode="primary" 
            :text="$t('app.save')" 
            icon="save" 
            @click="submitForm('ruleForm')" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <input-text-mail-dialog 
        :dialogOpen="showModalHotFolder" 
        @toggleDialog="toggleModalHotFolder" 
        @applyDialog="testHotFolder"
        header="Enviar email de prueba" 
        headerValue="Destinatario" 
        />
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { Upload } from 'element-ui'
// import { getPersonalization } from '@/services/clients/getPersonalization'
import { getLogoCustom } from '@/services/clients/getLogoCustom'
import { getColorsCustom } from '@/services/clients/getColorsCustom'
import { getConfigSMTP } from '@/services/clients/getConfigSMTP'
import { getConfigCorreos } from '@/services/clients/getConfigCorreos'
import { getConfigCorreosTags } from '@/services/clients/getConfigCorreosTags'
import { updatePersonalization } from '@/services/clients/updatePersonalization' 
import { i18n } from '@/i18n'
import { COLORES_PREDEFINIDOS } from '@/config/colores-predefinidos'
import { getClient } from '@/services/clients/getClient'

import TextEditor from '@/components/texteditor/TextEditor.vue'
import { getCamposMetadatos } from '@/services/notifications/getCamposMetadatos'
import { getModulosClienteId } from '@/services/clients/getModulosClienteId' 

import InputTextMailDialog from '@/components/InputTextMailDialog.vue'
import { enviocorreoprueba } from '@/services/clients/enviocorreoprueba' 

import { email as emailRegex } from '@/utils/regex'

import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

function isValidNum (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 999999) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'personalization-detail',
  components: {
    DetailLayoutFullWidth,
    Upload,
    TextEditor,
    InputTextMailDialog,
    Cropper,
  },
  data: function () {
    return {
      isMounted: false,
      activeName: 'es',
      header: {
        title: i18n.t('clients.personalization_client'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations/clients'
      },
      showModalHotFolder: false,
      showTestHotFolder: false,

      croppedLight: false,
      croppedDark: false,
      stencilProps: {
        aspectRatio: 300 / 74,
        stencilSize: { width: 300, height: 74 }, 
        stencilResizable: false, 
      },

      colorSelected: null,
      predefineColors: COLORES_PREDEFINIDOS,
      valuesCamposMetadatos: [],

      tooltipContentLogo: i18n.t('tooltip.logo'),
      msgDefaultDisabledEditor: '<p>El formato del cuerpo actual no es compatible con el editor.</p><p>Consulte con soporte@zerocoma.com si desea cambiarlo.</p>',
      customMailNew: false,
      customMailDownload: false,
      customMailAviso: false,
      customMailTramit: false,
      customMailVinc: false,
      customMailVincEnlace: false,
      customMailManual: false,
      customMailNuevoUsuario: false,
      customMailRecuperacionPass: false,
      customMailDobleAuth: false,
      customMailOtrosAvisos: false,
      customMailEspacio: false,
      customMailNeos: false,
      customMailSMS: false,

      visibleEditPass: true,
      disableEditPass: true,

      listaIDsModulosClientes: [],
      form: {
        smtpMain: false,
        smtpServer: null,
        smtpFrom: null,
        smtpPort: null,
        smptSSL: true,
        smptOAuth2: null,
        smtpRelay: false,
        smptClientId: null,
        smptTenantId: null,
        smtpUser: null,
        smtpPass: null,
        // smptConfirmacionEntrega: false,
        asuntoMailNew: '',
        asuntoMailDownload: '',
        asuntoMailAviso: '',
        asuntoMailTramit: '',
        asuntoMailVinc: '',
        asuntoMailVincEnlace: '',
        asuntoMailManual: '',
        asuntoMailNuevoUsuario: '',
        asuntoMailRecuperacionPass: '',
        asuntoMailDobleAuth: '',
        asuntoMailOtrosAvisos: '',
        asuntoMailNeos: '',
        asuntoMailEspacio: '',
        asuntoMailSMS: '',
      },
      // Contenido para cada TextEditor
      contentTextEditorDefaultNew: '',
      contentTextEditorDefaultDownload: '',
      contentTextEditorDefaultAviso: '',
      contentTextEditorDefaultTramit: '',
      contentTextEditorDefaultVinc: '',
      contentTextEditorDefaultVincEnlace: '',
      contentTextEditorDefaultManual: '',
      contentTextEditorDefaultOtrosAvisos: '',
      contentTextEditorDefaultEspacio: '',
      contentTextEditorDefaultNeos: '',
      contentTextEditorDefaultSMS: '',
      contentTextEditorDefaultNuevoUsuario: '',
      contentTextEditorDefaultRecuperacionPass: '',
      contentTextEditorDefaultDobleAuth: '',
      // Etiquetas para cada TextEditor
      tagsCustomMailNew: [],
      tagsCustomMailDownload: [],
      tagsCustomMailAviso: [],
      tagsCustomMailTramit: [],
      tagsCustomMailVinc: [],
      tagsCustomMailVincEnlace: [],
      tagsCustomMailManual: [],
      tagsCustomMailNuevoUsuario: [],
      tagsCustomMailRecuperacionPass: [],
      tagsCustomMailDobleAuth: [],
      tagsCustomMailOtrosAvisos: [],
      tagsCustomMailEspacio: [],
      tagsCustomMailNeos: [],
      tagsCustomMailSMS: [],

      maxSizefile: 1048576, // Bytes (1MB)
      fileLight: {
        name: '',
        b64: '',
        bytes: null,
      },
      fileDark: {
        name: '',
        b64: '',
        bytes: null,
      },
      rules: {
        asuntoMailNew: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        asuntoMailDownload: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        asuntoMailAviso: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        asuntoMailTramit: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        asuntoMailVinc: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        asuntoMailVincEnlace: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        asuntoMailManual: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        fileLight: [
          // {
          //   message: this.$i18n.t('app.fill_data'),
          //   trigger: ['blur', 'change'],
          //   validator: (rule, value, callback) => {
          //     if (!this.fileLight.name) {
          //       this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
          //     } else {
          //       callback()
          //     }
          //   }
          // },
          {
            message: this.$i18n.t('validation.not_logo_custom'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name && 
                (this.fileLight.name.length < 5 || 
                (!this.isValidExtension(this.fileLight.name)))
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_logo_custom'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.logo_recortar'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLight.name &&
                this.croppedLight === false
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.logo_recortar'), callback)
              } else {
                callback()
              }
            }
          },
        ],
        fileDark: [
          // {
          //   message: this.$i18n.t('app.fill_data'),
          //   trigger: ['blur', 'change'],
          //   validator: (rule, value, callback) => {
          //     if (!this.fileDark.name) {
          //       this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
          //     } else {
          //       callback()
          //     }
          //   }
          // },
          {
            message: this.$i18n.t('validation.not_logo_custom'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name && 
                (this.fileDark.name.length < 5 || 
                (!this.isValidExtension(this.fileLight.name)))
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_logo_custom'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.logo_recortar'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileDark.name &&
                this.croppedDark === false
              ) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.logo_recortar'), callback)
              } else {
                callback()
              }
            }
          },
        ],
        smtpServer: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpFrom: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        smtpPort: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        smptClientId: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smptTenantId: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpUser: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpPass: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      },
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    colorSelected: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileLight: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileDark: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNew: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailDownload: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailAviso: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailTramit: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailVinc: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailVincEnlace: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailManual: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNuevoUsuario: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailRecuperacionPass: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailDobleAuth: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailOtrosAvisos: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailNeos: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailEspacio: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    gettextEditorCustomMailSMS: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    isPasswordSmtpVisible: function (value, oldValue) {
      if (value) this.fixAccesibilityElInputPass()
    },
  },
  computed: {
    validLightImage () {
      if (!this.fileLight) return false
      return this.fileLight.b64 && this.isValidExtension(this.fileLight.name)
    },
    validDarkImage () {
      if (!this.fileDark) return false
      return this.fileDark.b64 && this.isValidExtension(this.fileDark.name)
    },
    srcImageLight () {
      if (!this.$refs.baseCollapsibleLogo?.isActive) return null
      if (!this.fileLight || !this.fileLight.b64) return null
      return 'data:image/png;base64, ' + this.fileLight?.b64
    },
    srcImageDark () {
      if (!this.$refs.baseCollapsibleLogo?.isActive) return null
      if (!this.fileDark || !this.fileDark.b64) return null
      return 'data:image/png;base64, ' + this.fileDark?.b64
    },
    isPasswordSmtpVisible () {
      return this.form.smtpMain && (this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) && (!this.form.smtpRelay)
    },
    gettextEditorCustomMailNew () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailNew.getContent()
    },
    gettextEditorCustomMailDownload () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailDownload.getContent()
    },
    gettextEditorCustomMailAviso () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailAviso.getContent()
    },
    gettextEditorCustomMailTramit () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailTramit.getContent()
    },
    gettextEditorCustomMailVinc () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailVinc.getContent()
    },
    gettextEditorCustomMailVincEnlace () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailVincEnlace.getContent()
    },
    gettextEditorCustomMailManual () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailManual.getContent()
    },
    gettextEditorCustomMailNuevoUsuario () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailNuevoUsuario.getContent()
    },
    gettextEditorCustomMailRecuperacionPass () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailRecuperacionPass.getContent()
    },
    gettextEditorCustomMailDobleAuth () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailDobleAuth.getContent()
    },
    gettextEditorCustomMailOtrosAvisos () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailOtrosAvisos.getContent()
    },
    gettextEditorCustomMailEspacio () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailEspacio.getContent()
    },
    gettextEditorCustomMailNeos () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailNeos.getContent()
    },
    gettextEditorCustomMailSMS () {
      if (!this.isMounted) return
      if (!this.hasModuleCustomMails) return null
      return this.$refs.textEditorCustomMailSMS.getContent()
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasModuleCustomSMTPCliente'] && (this.listaIDsModulosClientes.includes(17) || this.role === 'Administrador')
    },
    hasModuleCustomSMTPZerocoma () {
      return this.$store.getters['auth/hasModuleCustomSMTPZerocoma'] && this.listaIDsModulosClientes.includes(16) && this.role === 'SuperAdministrador'
    },
    hasModuleCustomLogo () {
      return this.$store.getters['auth/hasModuleCustomLogo'] && (this.listaIDsModulosClientes.includes(19) || this.role === 'Administrador')
    },
    hasModuleCustomColors () {
      return this.$store.getters['auth/hasModuleCustomColors'] && (this.listaIDsModulosClientes.includes(22) || this.role === 'Administrador')
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails'] && (this.listaIDsModulosClientes.includes(18) || this.role === 'Administrador')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasLogoLightSaved () {
      return this.fileLight && this.fileLight.b64 
    },
    hasLogoDarkSaved () {
      return this.fileDark && this.fileDark.b64 
    }
  },
  created: async function () {
    const breadcrumbs = []

    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
      }
    }

    this.header.breadcrumb = breadcrumbs

    if (this.role !== 'Administrador') {
      const dataModulosCliente = await getModulosClienteId({ idCliente: this.id })
      if (dataModulosCliente.blnError === false) {
        this.listaIDsModulosClientes = dataModulosCliente.Respuesta
      } else {
        this.doFeedback(dataModulosCliente.msgError + ' [Código de error: ' + dataModulosCliente.codError + ']')
      }
    }

    this.$store.commit('setIsLoading', true)
    const dataColors = await this.downloadDataColors(this.id)
    this.setDataColors(dataColors)
    const dataSmtp = await this.downloadDataSmtp(this.id)
    this.setDataSmtp(dataSmtp.ConfigSMTP)
    const dataCorreos = await this.downloadDataCorreos(this.id)
    this.setDataCorreos(dataCorreos.Plantillas)
    const dataCorreosTags = await this.downloadDataCorreosTags(this.id)
    this.setDataCorreosTags(dataCorreosTags.Tags)
    const dataLogo = await this.downloadDataLogo(this.id)
    this.setDataLogo(dataLogo)
    this.$store.commit('setIsLoading', false)

    // Carga de campos de metadatos
    const metadatos = await getCamposMetadatos()
    if (metadatos.blnError) {
      this.doFeedback(metadatos.msgError + ' [Código de error: ' + metadatos.codError + ']')
    } else {
      const self = this
      metadatos.Respuesta.forEach(function (value, i) {
        const metadato = { Nombre: value, id: i }
        self.valuesCamposMetadatos.push(metadato)
      })
    }
  },
  mounted () {
    this.isMounted = true
    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    this.resetControlFormChanges()
    this.fixAccesibilityElInputPass()
  },
  methods: {
    isValidExtension (fileName) {
      if (!fileName || fileName.length < 5) return false
      const extension = this.getExtensionFromFile(fileName).toUpperCase()
      return extension === 'PNG' || extension === 'WEBP' ||
        extension === 'JPG' || extension === 'JPEG'
    },
    recortarModoClaro: async function () {
      const b64 = await this.cropImage('cropperLight')
      this.fileLight.b64 = b64
      this.croppedLight = true
    },
    recortarModoOscuro: async function () {
      const b64 = await this.cropImage('cropperDark')
      this.fileDark.b64 = b64
      this.croppedDark = true
    },
    cropImage: async function (refName) {
      if (!this.$refs[refName]) return

      const result = this.$refs[refName].getResult(/* {width: 300, height: 74, } */)
      
      const targetWidth = 300
      const targetHeight = 74
      const resizedCanvas = document.createElement('canvas')
      resizedCanvas.width = targetWidth
      resizedCanvas.height = targetHeight

      const ctx = resizedCanvas.getContext('2d')
      ctx.drawImage(result.canvas, 0, 0, targetWidth, targetHeight)

      // Retornamos una promesa que resuelve con el base64
      return new Promise(resolve => {
        resizedCanvas.toBlob(async blob => {
          const b64 = await this.blobToBase64(blob)
          resolve(b64)
        }, 'image/png')
      })
    },
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result.split(',')[1]) // quita el encabezado data:
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    fixAccesibilityElInputPass () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputPassPersonalization, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    toggleModalHotFolder () {
      this.showModalHotFolder = !this.showModalHotFolder
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    editSmtpPassToggle () {
      if (this.disableEditPass) this.form.smtpPass = ''
      else this.form.smtpPass = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    toggleShowHidePass (disable = true) {
      this.form.smtpPass = disable ? '**********' : ''
      this.disableEditPass = disable
      this.visibleEditPass = disable
    },
    handleChangeLight: function (fileLight) {
      this.croppedLight = false
      this.$refs.uploadlogo.clearValidate()
      this.fileLight.name = fileLight.name
      this.getBase64(fileLight.raw).then(res => {
        const b64 = res.split(',')
        this.fileLight.b64 = b64[1]
      })
      this.fileLight.bytes = fileLight
    },
    handleChangeDark: function (fileDark) {
      this.croppedDark = false
      this.$refs.uploadlogo.clearValidate()
      this.fileDark.name = fileDark.name
      this.getBase64(fileDark.raw).then(res => {
        const b64 = res.split(',')
        this.fileDark.b64 = b64[1]
      })
      this.fileDark.bytes = fileDark
    },
    handleRemoveLight: function () {
      this.croppedLight = false
      this.fileLight.name = null
      this.fileLight.b64 = null
      this.fileLight.bytes = null
    },
    handleRemoveDark: function () {
      this.croppedDark = false
      this.fileDark.name = null
      this.fileDark.b64 = null
      this.fileDark.bytes = null
    },
    testHotFolder: async function (destinatario) {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await enviocorreoprueba({ 
          idCliente: this.id,
          destinatario: destinatario,
        })
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.toggleModalHotFolder()
          this.doFeedback('Prueba realizada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    isNumberValid: function (rule, value, callback) {
      if (!value || value === '') {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        // callback()
      } else if (!isValidNum(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.number'), callback)
      } else {
        callback()
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    submitForm: function (formName, test = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idCliente: this.id,
            Logo: this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name
              ? {
                Contenido: this.fileLight.b64,
                Extension: this.getExtensionFromFile(this.fileLight.name)
              } 
              : null,
            LogoDark: this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name
              ? {
                Contenido: this.fileDark.b64,
                Extension: this.getExtensionFromFile(this.fileDark.name)
              }
              : null,
            Color: this.hasModuleCustomColors ? this.colorSelected : null,
            ConfigSMTP: (this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma)
              ? {
                Activo: this.form.smtpMain,
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                Relay: this.form.smtpRelay,
                ClientId: this.form.smptOAuth2 ? this.form.smptClientId : null,
                TenantId: this.form.smptOAuth2 ? this.form.smptTenantId : null,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
            PlantillasCorreos: this.hasModuleCustomMails 
              ? {
                AsuntoAvisoNuevaNotificacion: this.form.asuntoMailNew,
                AsuntoAvisoDescargaNotificacion: this.form.asuntoMailDownload,
                AsuntoAvisoNotificacionesDiarias: this.form.asuntoMailAviso,
                AsuntoAvisoNotificacionTramitada: this.form.asuntoMailTramit,
                AsuntoAvisoNotificacionVinculada: this.form.asuntoMailVinc,
                AsuntoAvisoNotificacionVinculadaEnlace: this.form.asuntoMailVincEnlace,
                AsuntoAvisoNotificacionEnvioManual: this.form.asuntoMailManual,
                AsuntoUsuarioNuevo: this.form.asuntoMailNuevoUsuario,
                AsuntoRecuperacionPassword: this.form.asuntoMailRecuperacionPass,
                AsuntoDobleAuth: this.form.asuntoMailDobleAuth,
                AsuntoAvisoOtros: this.form.asuntoMailOtrosAvisos,
                AsuntoAvisoEspacioSuperado: this.form.asuntoMailEspacio,
                AsuntoAvisoNotificacionesSuperadas: this.form.asuntoMailNeos,
                AsuntoAvisoSMSSuperado: this.form.asuntoMailSMS,
                CuerpoAvisoNuevaNotificacion: this.customMailNew ? this.gettextEditorCustomMailNew : this.contentTextEditorDefaultNew,
                CuerpoAvisoDescargaNotificacion: this.customMailDownload ? this.gettextEditorCustomMailDownload : this.contentTextEditorDefaultDownload,
                CuerpoAvisoNotificacionesDiarias: this.customMailAviso ? this.gettextEditorCustomMailAviso : this.contentTextEditorDefaultAviso,
                CuerpoAvisoNotificacionTramitada: this.customMailTramit ? this.gettextEditorCustomMailTramit : this.contentTextEditorDefaultTramit,
                CuerpoAvisoNotificacionVinculada: this.customMailVinc ? this.gettextEditorCustomMailVinc : this.contentTextEditorDefaultVinc,
                CuerpoAvisoNotificacionVinculadaEnlace: this.customMailVincEnlace ? this.gettextEditorCustomMailVincEnlace : this.contentTextEditorDefaultVincEnlace,
                CuerpoAvisoNotificacionEnvioManual: this.customMailManual ? this.gettextEditorCustomMailManual : this.contentTextEditorDefaultManual,
                CuerpoUsuarioNuevo: this.customMailNuevoUsuario ? this.gettextEditorCustomMailNuevoUsuario : this.contentTextEditorDefaultNuevoUsuario,
                CuerpoRecuperacionPassword: this.customMailRecuperacionPass ? this.gettextEditorCustomMailRecuperacionPass : this.contentTextEditorDefaultRecuperacionPass,
                CuerpoDobleAuth: this.customMailDobleAuth ? this.gettextEditorCustomMailDobleAuth : this.contentTextEditorDefaultDobleAuth,
                CuerpoAvisoOtros: this.customMailOtrosAvisos ? this.gettextEditorCustomMailOtrosAvisos : this.contentTextEditorDefaultOtrosAvisos,
                CuerpoAvisoEspacioSuperado: this.customMailEspacio ? this.gettextEditorCustomMailEspacio : this.contentTextEditorDefaultEspacio,
                CuerpoAvisoNotificacionesSuperadas: this.customMailNeos ? this.gettextEditorCustomMailNeos : this.contentTextEditorDefaultNeos,
                CuerpoAvisoSMSSuperado: this.customMailSMS ? this.gettextEditorCustomMailSMS : this.contentTextEditorDefaultSMS,
              } 
              : null,
          }
          const response = await updatePersonalization({ idEmpresa: this.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.showTestHotFolder = true
            this.doFeedback('Datos actualizados correctamente', 'success')
            if ((this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) && this.form.smtpMain) {
              this.toggleShowHidePass(!this.form.smtpRelay)
            }
            if (this.hasModuleCustomLogo && this.fileLight && this.fileLight.b64 && this.fileLight.name) {
              this.fileLight.b64 = payload.Logo.Contenido
            }
            if (this.hasModuleCustomLogo && this.fileDark && this.fileDark.b64 && this.fileDark.name) {
              this.fileDark.b64 = payload.LogoDark.Contenido
            }
            await this.$store.dispatch('app/getColors')
            await this.$store.dispatch('app/updateFrontColors')
            this.resetControlFormChanges()
            if (test) {
              this.toggleModalHotFolder()
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.role === 'Administrador') {
        this.$router.push({ name: 'configurations' })
      } else {
        if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
        else this.$router.push({ name: 'configurations/clients' })
      }
    },
    downloadDataLogo: async function (id) {
      try {
        const template = await getLogoCustom({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataColors: async function () {
      try {
        const response = await getColorsCustom({ idCliente: this.id })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          return response
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataSmtp: async function (id) {
      try {
        const template = await getConfigSMTP({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataCorreos: async function (id) {
      try {
        const template = await getConfigCorreos({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    downloadDataCorreosTags: async function (id) {
      try {
        const template = await getConfigCorreosTags({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } 
      return null
    },
    setDataLogo: function (data) {
      if (data) {
        if (data.Logo?.Contenido) this.croppedLight = true
        this.fileLight.b64 = data.Logo?.Contenido 
        this.fileLight.name = data.Logo 
          ? 'logo-claro.' + data.Logo?.Extension 
          : null
        if (data.LogoDark?.Contenido) this.croppedDark = true
        this.fileDark.b64 = data.LogoDark?.Contenido
        this.fileDark.name = data.LogoDark
          ? 'logo-oscuro.' + data.LogoDark?.Extension
          : null
      }
      this.resetControlFormChanges()
    },
    setDataColors (data) {
      if (data) {
        this.colorSelected = data.Color
      }
      this.resetControlFormChanges()
    },
    setDataSmtp: function (data) {
      if (data) {
        this.form.smtpMain = data.Activo
        this.form.smtpServer = data.Servidor
        this.form.smtpFrom = data.UsrDefecto
        this.form.smtpPort = data.Puerto
        this.form.smptSSL = data.SSL
        this.form.smptClientId = data.ClientId
        this.form.smptTenantId = data.TenantId
        this.form.smtpUser = data.Usuario
        this.form.smptOAuth2 = !(!data.ClientId && !data.TenantId)
        this.form.smtpRelay = data.Relay
        this.toggleShowHidePass(!this.form.smtpRelay)
        this.showTestHotFolder = true
      } else {
        this.form.smtpMain = false
        this.visibleEditPass = false
        this.disableEditPass = false
      }
      this.resetControlFormChanges()
    },
    setDataCorreos: function (data) {
      if (data) {
        this.form.asuntoMailNew = data.AsuntoAvisoNuevaNotificacion
        this.form.asuntoMailDownload = data.AsuntoAvisoDescargaNotificacion
        this.form.asuntoMailAviso = data.AsuntoAvisoNotificacionesDiarias
        this.form.asuntoMailTramit = data.AsuntoAvisoNotificacionTramitada
        this.form.asuntoMailVinc = data.AsuntoAvisoNotificacionVinculada
        this.form.asuntoMailVincEnlace = data.AsuntoAvisoNotificacionVinculadaEnlace
        this.form.asuntoMailManual = data.AsuntoAvisoNotificacionEnvioManual
        this.form.asuntoMailNuevoUsuario = data.AsuntoUsuarioNuevo
        this.form.asuntoMailRecuperacionPass = data.AsuntoRecuperacionPassword
        this.form.asuntoMailDobleAuth = data.AsuntoDobleAuth
        this.form.asuntoMailOtrosAvisos = data.AsuntoAvisoOtros
        this.form.asuntoMailNeos = data.AsuntoAvisoNotificacionesSuperadas
        this.form.asuntoMailEspacio = data.AsuntoAvisoEspacioSuperado
        this.form.asuntoMailSMS = data.AsuntoAvisoSMSSuperado
          
        // Contenido
        this.contentTextEditorDefaultNew = data.CuerpoAvisoNuevaNotificacion
        this.contentTextEditorDefaultDownload = data.CuerpoAvisoDescargaNotificacion
        this.contentTextEditorDefaultAviso = data.CuerpoAvisoNotificacionesDiarias

        this.contentTextEditorDefaultTramit = data.CuerpoAvisoNotificacionTramitada
        this.contentTextEditorDefaultVinc = data.CuerpoAvisoNotificacionVinculada
        this.contentTextEditorDefaultVincEnlace = data.CuerpoAvisoNotificacionVinculadaEnlace
        this.contentTextEditorDefaultManual = data.CuerpoAvisoNotificacionEnvioManual
        this.contentTextEditorDefaultNuevoUsuario = data.CuerpoUsuarioNuevo
        this.contentTextEditorDefaultRecuperacionPass = data.CuerpoRecuperacionPassword
        this.contentTextEditorDefaultDobleAuth = data.CuerpoDobleAuth
        this.contentTextEditorDefaultOtrosAvisos = data.CuerpoAvisoOtros
        this.contentTextEditorDefaultEspacio = data.CuerpoAvisoEspacioSuperado
        this.contentTextEditorDefaultNeos = data.CuerpoAvisoNotificacionesSuperadas
        this.contentTextEditorDefaultSMS = data.CuerpoAvisoSMSSuperado

        // Es editable a través del editor ?
        this.customMailNew = data.CuerpoAvisoNuevaNotificacionEditable
        this.customMailDownload = data.CuerpoAvisoDescargaNotificacionEditable
        this.customMailAviso = data.CuerpoAvisoNotificacionesDiariasEditable
        this.customMailTramit = data.CuerpoAvisoNotificacionTramitadaEditable
        this.customMailVinc = data.CuerpoAvisoNotificacionVinculadaEditable
        this.customMailVincEnlace = data.CuerpoAvisoNotificacionVinculadaEnlaceEditable
        this.customMailManual = data.CuerpoAvisoNotificacionEnvioManualEditable
        this.customMailNuevoUsuario = data.CuerpoUsuarioNuevoEditable
        this.customMailRecuperacionPass = data.CuerpoRecuperacionPasswordEditable
        this.customMailDobleAuth = data.CuerpoDobleAuthEditable
        this.customMailOtrosAvisos = data.CuerpoAvisoOtrosEditable
        this.customMailEspacio = data.CuerpoAvisoEspacioSuperadoEditable
        this.customMailNeos = data.CuerpoAvisoNotificacionesSuperadas
        this.customMailSMS = data.CuerpoAvisoSMSSuperadoEditable
      }
      this.resetControlFormChanges()
    },
    setDataCorreosTags: function (data) {
      if (data) {
        // Tags
        this.tagsCustomMailNew = data.filter(x => x.Nombre === 'AvisoNuevaNotificacion')[0].Tags
        this.tagsCustomMailDownload = data.filter(x => x.Nombre === 'AvisoDescargaNotificacion')[0].Tags
        this.tagsCustomMailAviso = data.filter(x => x.Nombre === 'AvisoNotificacionesDiarias')[0].Tags
        this.tagsCustomMailTramit = data.filter(x => x.Nombre === 'AvisoNotificacionTramitada')[0].Tags
        this.tagsCustomMailVinc = data.filter(x => x.Nombre === 'AvisoNotificacionVinculada')[0].Tags
        this.tagsCustomMailVincEnlace = data.filter(x => x.Nombre === 'AvisoNotificacionVinculadaEnlace')[0].Tags
        this.tagsCustomMailManual = data.filter(x => x.Nombre === 'AvisoNotificacionEnvioManual')[0]?.Tags
        this.tagsCustomMailNuevoUsuario = data.filter(x => x.Nombre === 'UsuarioNuevo')[0].Tags
        this.tagsCustomMailRecuperacionPass = data.filter(x => x.Nombre === 'RecuperacionPassword')[0].Tags
        this.tagsCustomMailDobleAuth = data.filter(x => x.Nombre === 'DobleAuth')[0].Tags
        this.tagsCustomMailOtrosAvisos = data.filter(x => x.Nombre === 'AvisoOtros')[0].Tags
        this.tagsCustomMailEspacio = data.filter(x => x.Nombre === 'AvisoEspacioSuperado')[0].Tags
        this.tagsCustomMailNeos = data.filter(x => x.Nombre === 'AvisoNotificacionesSuperadas')[0].Tags
        this.tagsCustomMailSMS = data.filter(x => x.Nombre === 'AvisoSMSSuperado')[0].Tags
      }
      this.resetControlFormChanges()
    }
  }
}
</script>
